module.exports = __webpack_public_path__ + "static/media/mhc.f2698857.png";